import React, {useState, useEffect} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";
import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import SelectPlantonistaModal from "./SelectPlantonistaModal";
import moment from "moment";
import "moment/locale/pt-br";
import locale from "antd/es/date-picker/locale/pt_BR"; // Importando o locale do antd
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
import './assets/css/Duty.css';
import dayjs from 'dayjs';
import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import ImportModal from "../import/ImportModal";
import CustomPagination from "../util/CustomPagination";

const {RangePicker} = DatePicker;


moment.locale('pt-br');

const DutyApproveManagers = () => {
    document.title = "Aprovar Plantão | Plantão Rápido";
    const user = AuthService.getUserData();
    const today = moment();
    const oneMonthFromNow = moment().add(1, 'month');
    const [showImportModal, setShowImportModal] = useState(false);
    const [docTypeModalData, setDocTypeModalData] = useState(null);
    const [users, setUsers] = useState(AuthService.getUserData());
    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectPlantonistaVisible, setSelectPlantonistaVisible] = useState(false);
    const [selectedDuty, setSelectedDuty] = useState(null);
    const [filters, setFilters] = useState({
        dateRange: "",
        datestart: null,
        dateend: null,
        status: "",
        hospital: "",
    });
    const [pagination, setPagination] = useState({current: 0, pageSize: 10, total: 0, lastPage: 0});

    useEffect(() => {
        fetchDuties(1, false, false);
    }, []);


    const handleSearchFiltersChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    const fetchDuties = async (page = 1) => {


        try {
            // Define o responseType baseado no tipo de exportação

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}duty/duty-approve-pending-list`,
                {
                    pagination: pagination.pageSize,
                    page: page
                },
                true
            );
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setDuties(data || []);
            setPagination(pagInfo || {current: 0, pageSize: 10, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    const handleModalOpen = (duty = null) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalClose = (save = false) => {
        setModalVisible(false);
        setSelectedDuty(null);
        if(save) {
            fetchDuties(pagination.current, false, false); // Refresh the list after modal is closed
        }
    };

    const handleSelectPlantonistaOpen = (duty) => {
        setSelectedDuty(duty);
        setSelectPlantonistaVisible(true);
    };

    const handleSelectPlantonistaClose = () => {
        setSelectPlantonistaVisible(false);
        setSelectedDuty(null);
    };

    const handlePlantonistaSelected = async (plantonistaId) => {
        try {
            await ApiService.send("post", `${process.env.REACT_APP_URL_API}duty/manageDutyAcceptance`, {
                dutyId: selectedDuty.id,
                userId: plantonistaId,
            });
            Swal.fire({
                title: 'Sucesso!',
                text: 'Plantonista selecionado com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            fetchDuties();
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setSelectPlantonistaVisible(false);
        }
    };

    const handleFilterChange = (changedFilters) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...changedFilters,
        }));
    };


    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            datestart: null,
            dateend: null,
            status: "",
            hospital: "",
        });
    };

    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            handleFilterChange({hospital: hospital.value});
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            handleFilterChange({hospital: null});
        }
    };


    const calculateDuration = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const duration = intervalToDuration({start: startDate, end: endDate});
        return formatDuration(duration, {format: ["hours", "minutes"], locale: ptBR});
    };

    const handleImport = () => {
        setShowImportModal(true);
    };

    const handlePDF = () => {
        fetchDuties(1, true, true);
    };
    const handleHideImportModal = () => {
        setShowImportModal(false);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Aprovar Plantão" pageTitle="Plantão"/>
                    <Row>
                                        <div className="list-container mt-4">
                                            {loading ? (
                                                <>
                                                    <div className="card duty-card shadow-sm mb-3">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-3">
                                                                    <Skeleton width={150} height={150}/>
                                                                </div>
                                                                <div className="col-9">
                                                                    <Skeleton width={200}/>
                                                                    <p>
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                duties.length > 0 ? (
                                                    duties.map((duty) => (
                                                        <Col lg={12} key={duty.id}>
                                                            <Card className="mb-2 p-1 shadow-sm card-hover duty-card" key={duty.id}>
                                                                <CardBody
                                                                    className="p-2 d-flex justify-content-between align-items-start">
                                                                    <div className="col-10 d-flex">
                                                                        <img
                                                                            src={duty.hospital?.images[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                                            alt={duty.hospital?.name || "Hospital"}
                                                                            style={{
                                                                                width: 60,
                                                                                height: 60,
                                                                                objectFit: "cover"
                                                                            }}
                                                                            className="rounded me-3"
                                                                        />

                                                                        <div className="w-100">
                                                                            <h6 className="mb-1"
                                                                                style={{fontSize: "0.95rem"}}>{duty.hospital?.name}</h6>
                                                                            <p className="mb-1"
                                                                               style={{fontSize: "0.8rem"}}>
                                                                                <i className="fa fa-map-marker text-info me-1"></i>
                                                                                {duty.hospital?.city?.name}, {duty.hospital?.uf} &nbsp;
                                                                                {duty.department?.name && (
                                                                                    <><i
                                                                                        className="fa fa-building text-info me-1"></i>{duty.department.name}</>
                                                                                )}
                                                                            </p>
                                                                            <p className="mb-1"
                                                                               style={{fontSize: "0.8rem"}}>
                                                                                <i className="fa fa-hourglass text-info me-1"
                                                                                   aria-hidden="true"></i>
                                                                                {calculateDuration(duty.date_time, duty.date_time_end)}
                                                                            </p>
                                                                            <div>
                                                                                {duty.specialties?.map((s) => (
                                                                                    <Tag key={s.id} color="blue"
                                                                                         style={{fontSize: "0.75rem"}}>{s.name}</Tag>
                                                                                ))}
                                                                            </div>
                                                                            <p className="text-muted mb-1">
                                                                                <i className="fa fa-calendar text-info"
                                                                                   style={{marginRight: "8px"}}></i>
                                                                                {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                                                {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                })}
                                                                                &nbsp;&nbsp;&nbsp;&nbsp;

                                                                                {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                                                {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                })}
                                                                            </p>
                                                                            {duty.observation && (
                                                                                <p className="text-muted mt-1"
                                                                                   style={{fontSize: "0.75rem"}}>
                                                                                    <i className="far fa-file-alt text-info me-1"></i>
                                                                                    {duty.observation.length > 60 ? `${duty.observation.slice(0, 60)}...` : duty.observation}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-2 text-end">
                                                                            <div
                                                                                className="doc-info-right ms-lg-auto text-end mt-3">

                                                                                <div
                                                                                    className="d-flex justify-content-between align-items-center mb-2">
                                                                                    {duty.accept_user && (
                                                                                        <div
                                                                                            className="d-flex align-items-center">
                                                                                            <Avatar
                                                                                                src={duty.accept_user.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                                                style={{
                                                                                                    width: 60,
                                                                                                    height: 60,
                                                                                                    objectFit: "cover"
                                                                                                }}
                                                                                                className="me-2" // Adicionando margem à direita do Avatar para espaçamento
                                                                                            />
                                                                                            <span>{duty.accept_user.name}</span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <p className="text-success fs-4 mb-2 text-center">
                                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                                        style: "currency",
                                                                                        currency: "BRL",
                                                                                    }).format(duty.value)}
                                                                                </p>
                                                                            </div>



                                                                            {duty.active === 1 &&
                                                                                !duty.accept?.some(item => item.status === 'reposting') && (
                                                                                    <button
                                                                                        type="button"
                                                                                        // disabled={!duty.interested_user || duty.interested_user.length === 0}
                                                                                        className="btn btn-info btn-sm ql-color-white" // Adicionada a classe w-100
                                                                                        title={
                                                                                            !duty.interested_user || duty.interested_user.length === 0
                                                                                                ? "Nenhum plantonista interessado disponível para seleção."
                                                                                                : ""
                                                                                        }
                                                                                        onClick={() => handleSelectPlantonistaOpen(duty)}>
                                                                                        <i className="fa fa-user"></i> Selecionar
                                                                                        Plantonista
                                                                                    </button>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))
                                                ) : (

                                                    <div className="alert alert-primary" role="alert">Nenhum plantão
                                                        encontrado.

                                                    </div>

                                                )
                                            )}
                                        </div>
                        <CustomPagination
                            className="mt-4"
                            pagination={pagination}
                            onChange={(page) => fetchDuties(page)}
                        />


                        <PlantaoModal
                            show={modalVisible}
                            handleClose={handleModalClose}
                            handleSubmit={fetchDuties}
                            duty={selectedDuty}
                        />
                        <SelectPlantonistaModal
                            show={selectPlantonistaVisible}
                            handleClose={handleSelectPlantonistaClose}
                            duty={selectedDuty}
                            // onPlantonistaSelected={fetchDuties}
                        />
                        <ImportModal
                            show={showImportModal}
                            onHide={handleHideImportModal}
                            initialData={docTypeModalData}
                            importType={2}
                        />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
);
};

export default DutyApproveManagers;
